import { BrowserRouter, Routes, Route } from "react-router-dom";
import RootLayout from "./rootLayout";
import Dashboard from "./component/dashboard/dashboardPage.jsx";
import About from "./component/about/aboutPage.tsx";
import Contact from "./component/contact/contactPage.tsx";
import Home from "./component/homePage/home.jsx";
import "./App.css";
import GoogleMapsPage from "./component/dashboard/google-maps.jsx";
import ElevenLabsConvai from "./component/ElevenLabsConvai.jsx";
// import Pricing from "./component/pricing/pricing.jsx";
// import Payment from "./component/pricing/payment.jsx";

const App = () => {
  return (
    <BrowserRouter>
      <RootLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/google-maps" element={<GoogleMapsPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/pricing" element={<Pricing />} />
          <Route path="/payment" element={<Payment />} /> */}
        </Routes>
      </RootLayout>
      <ElevenLabsConvai />
    </BrowserRouter>
  );
};

export default App;
